import clsx from 'clsx';
import { TFunction } from 'i18next';

import './PasswordHint.scss';

import useResources from 'hooks/useResources';

export const rules = (t: TFunction) => [
    { regex: /(?=.*[0-9])/, message: t('signUp.password.errors.hasNumber') },
    { regex: /(?=.*[!@#$%^&*])/, message: t('signUp.password.errors.hasSpecial') },
    { regex: /(?=.*[A-Z])/, message: t('signUp.password.errors.hasUppercase') },
    { regex: /(?=.*[a-z])/, message: t('signUp.password.errors.hasLowercase') },
    { regex: /.{8,}/, message: t('signUp.password.errors.minLength') },
];

type PasswordHintProps = {
    value: string;
    isWithLabel?: boolean;
};

const PasswordHint = (props: PasswordHintProps) => {
    const { value = '', isWithLabel = false } = props;

    const { t } = useResources();

    return (
        <div className={clsx(['password-hint-container', isWithLabel && 'with-label'])}>
            <div className="triangle" />
            {rules(t).map((rule, index) => {
                const isValid = value?.match(rule.regex);
                return (
                    <span
                        key={index}
                        className={clsx([
                            'password-hint',
                            isValid && 'password-hint-valid',
                            !isValid && 'password-hint-invalid',
                        ])}
                    >
                        {rule.message}
                    </span>
                );
            })}
        </div>
    );
};

export default PasswordHint;

export const passwordHintWrapperClassName = 'password-hint-wrapper';
